// extracted by mini-css-extract-plugin
module.exports = {"body":"marketing-body__body___2r6NU"};